export const AnalyticalEvents = {
  // 🧭 Onboarding
  OnboardingStart: 'product_onboarding_start',
  OnboardingStartOauth: 'product_onboarding_start_oauth',
  OnboardingEmailVerified: 'product_onboarding_email_verified',
  OnboardingStepCompleted: 'product_onboarding_step_completed',
  OnboardingProfileCompleted: 'product_onboarding_profile_completed',
  OnboardingComplete: 'product_onboarding_complete',

  // 🤖 AI Agent
  AIAgentPrompted: 'product_ai_agent_prompted',
  AIAgentSearchCompleted: 'product_ai_agent_search_completed',

  // 🔍 Discovery & Profiles
  DiscoverySearchCompleted: 'product_discovery_search_completed',
  ProfileUnlocked: 'product_profile_unlocked',
  ProfileInsightViewed: 'product_profile_insight_viewed',
  ProfileAudienceAnalysisViewed: 'product_profile_audience_analysis_viewed',

  // 📋 Lists & Campaigns
  ListCreated: 'product_list_created',
  ListItemAdded: 'product_list_item_added',
  CampaignCreated: 'product_campaign_created',
  CampaignLaunched: 'product_campaign_launched',

  // 📊 Reports
  ReportCreated: 'product_report_created',
  ReportViewed: 'product_report_viewed',
  ReportExported: 'product_report_exported',

  // 💰 Sales & Upgrades
  SalesUpgradeCtaViewed: 'product_sales_upgrade_cta_viewed',
  SalesUpgradeCtaClicked: 'product_sales_upgrade_cta_clicked',
  SalesSubscriptionTierSelected: 'product_sales_subscription_tier_selected',
  SalesContactClicked: 'product_sales_contact_clicked',

  // 🔐 Login
  Login: 'product_login',

  // 📈 Usage & Quotas
  UsageQuotaUsed: 'product_usage_quota_used',
  UsageUnlockQuotaMaxed: 'product_usage_unlock_quota_maxed',

  // 🚚 Move to app.streamforge.com
  LegacyRetirementBannerClicked: 'product_legacy_retirement_banner_clicked',
  LegacyRetirementLoginNoticeClicked: 'product_legacy_retirement_login_notice_clicked'
}

function getDeviceType() {
  if (navigator.userAgentData) {
    const { mobile } = navigator.userAgentData
    return {
      device: mobile ? 'mobile' : 'desktop'
    }
  }

  // Fallback for browsers that don’t support userAgentData
  const ua = navigator.userAgent
  if (/tablet|ipad|playbook|silk/i.test(ua)) return { device: 'tablet' }
  if (/mobile/i.test(ua)) return { device: 'mobile' }
  return { device: 'desktop' }
}


export function trackEvent(eventName, params = {}) {
  try {
    // Basic validation
    if (typeof window.gtag !== 'function') {
      console.warn('GA4 not initialized, event skipped:', eventName)
      return
    }

    // Enforce naming conventions
    const formattedEvent = eventName.toLowerCase().replace(/\s+/g, '_')

    // Add global context (optional)
    const defaultParams = {
      timestamp: new Date().toISOString(),
      device: getDeviceType().device,
    }

    window.gtag('event', formattedEvent, { ...defaultParams, ...params })
  } catch (err) {
    console.error('Failed to track event:', eventName, err)
  }
}

// Sets the GA4 user_id for all future events for the session
let currentUserId = null
export function setUserId(userId) {
  if (typeof window.gtag !== 'function') {
    // GA4 not yet initialized
    return
  }

  if (!userId) {
    console.warn('setUserId called without a valid userId')
    return
  }

  // Avoid redundant calls for the same user
  if (userId === currentUserId) return

  window.gtag('set', { user_id: userId })
  currentUserId = userId
}
